import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template", "fields", "destroy"]

  add(event) {
    event.preventDefault()

    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
    this.containerTarget.insertAdjacentHTML("beforeend", content)
  }

  remove(event) {
    event.preventDefault()

    const fields = event.target.closest("[data-nested-form-target='fields']")

    if (!fields) return

    const destroyField = fields.querySelector("[data-nested-form-target='destroy']")

    if (destroyField) {
      destroyField.value = "1"
      fields.classList.add("hidden")
    } else {
      fields.remove()
    }
  }
}
